import Pagination from "../modules/utils/pagination";
import Select from "../modules/utils/select";

class Career {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.htmlWrapper = this.root.querySelector(".career__jobs-wrapper");
        this.loader = this.root.querySelector(".loader");
        this.selects = this.root.querySelectorAll("select");
        this.form = this.root.querySelector("form");
        this.paginationWrapper = this.root.querySelector(".pagination");
        this.extraFiltersButton = this.root.querySelector(".career__extra-filters-button");

        this.paginationInstance = null;

        this.paginationSettings = this.paginationWrapper ? JSON.parse(this.paginationWrapper.getAttribute('data-settings')) : null;

        this.currentPage = 1;

        return true;
    }

    init() {
        this.initSelects();
        this.initPagination();
        this.handleForm();
        this.handleExtraFiltersButton();
    }

    initSelects() {

        if(this.selects && this.selects.length > 0) {
            this.selects.forEach(select => {
                const selectInstance = new Select(select.parentElement, this.root);
            });
        }
    }

    initPagination() {
        if (this.paginationWrapper) {
            this.paginationInstance = new Pagination(this.paginationWrapper, this.root);
            this.root.addEventListener('pagination-change', this.onPaginationChange.bind(this));
        }
    }

    handleForm() {
        if (this.form) {
            this.form.addEventListener("submit", (e) => {
                e.preventDefault();
                this.handleFormSubmit();
            });
        }
    }

    handleExtraFiltersButton() {
        if (this.extraFiltersButton) {
            this.extraFiltersButton.addEventListener("click", () => {
                this.extraFiltersButton.classList.add("hide");
                this.root.querySelectorAll(".career__form-item").forEach(item => item.classList.remove("-hide-mobile"));
            })
        }
    }

    onPaginationChange(event) {
        const {detail} = event;
        this.currentPage = parseInt(detail);
        this.handleFormSubmit(true);
    }

    async handleFormSubmit(isPaginationClick = false) {
        try {
            this.loader.classList.add("active");
            const formData = new FormData(this.form);
            formData.append("action", "handle_carrer");
            if (isPaginationClick) {
                formData.append("page", this.currentPage);
            }
            const req = await fetch(ajax.url, {
                method: "POST",
                body: formData
            });

            if (!req) {
                console.log(`Error: ${req}`);
                return;
            }

            const {html} = await req.json();

            if (html) {
                this.htmlWrapper.innerHTML = html;
                this.paginationWrapper = this.root.querySelector(".pagination");
                this.paginationSettings = this.paginationWrapper ? JSON.parse(this.paginationWrapper.getAttribute('data-settings')) : null;
                this.paginationInstance = new Pagination(this.paginationWrapper, this.root);
                
                if (this.paginationSettings) {
                    this.paginationInstance.reset(this.currentPage, this.paginationSettings.max_pages);
                }
            }

            this.loader.classList.remove("active");

            if (isPaginationClick) {
                window.scrollTo({
                    top: this.root.getBoundingClientRect().top + window.scrollY - 150,
                    behavior: 'smooth'
                })
            }

        } catch (error) {
            console.log(error);
            this.loader.classList.remove("active");
        }
    }

}

const careerSection = document.querySelector(".career");

if (careerSection) {
    new Career(careerSection);
}